import { VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { AllAdvisorsWarning } from './components/AllAdvisorsWarning';
import { Header } from './components/Header';
import { LeadCaptureAndConversion } from './components/LeadCaptureAndConversion';

export const Home: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  return (
    <ScrollView flex={1}>
      <View
        flex={1}
        width="100%"
        minW="container"
        px={{ base: 0, sm: 'inline.sm', lg: 'inline.sm' }}>
        <Header isMobile={isMobile} />
        <VStack
          paddingTop={{ base: 0, sm: 'stack.xxxs' }}
          paddingBottom="inline.xxxs"
          space="stack.xxxs"
          backgroundColor={{ base: 'neutral.white', sm: 'transparent' }}>
          <AllAdvisorsWarning />
          <LeadCaptureAndConversion isMobile={isMobile} isTablet={isTablet} />
        </VStack>
      </View>
    </ScrollView>
  );
};
